import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { dict } from "@/lib/i18n";

const SiteContext = createContext(null);

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [tours, setTours] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState("es");
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rdx_cart") || "[]"); } catch { return []; }
  });
  const [search, setSearch] = useState("");
  const [theme, setTheme] = useState(localStorage.getItem("rdx_theme") || "light");
  useEffect(() => { localStorage.setItem("rdx_theme", theme); }, [theme]);

  const refresh = useCallback(async () => {
    try {
      const [s, t, d] = await Promise.all([api.get("/settings"), api.get("/tours"), api.get("/destinations")]);
      setSettings(s.data); setTours(t.data); setDestinations(d.data);
    } catch (e) {
      console.error("load error", e);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    if (!settings) return;
    const r = document.documentElement.style;
    r.setProperty("--brand", settings.primary_color || "#2BB89A");
    r.setProperty("--accent-c", settings.accent_color || "#F2A93B");
    r.setProperty("--footer", settings.footer_color || "#0B3D6E");
    r.setProperty("--secondary", settings.secondary_color || "#1E73BE");
    document.title = `${settings.site_name} | Tours y Excursiones en República Dominicana`;
  }, [settings]);

  useEffect(() => { localStorage.setItem("rdx_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("rdx_lang", lang); }, [lang]);

  const addToCart = (item) => setCart((c) => [...c, { ...item, key: `${Date.now()}-${Math.random()}` }]);
  const removeFromCart = (key) => setCart((c) => c.filter((i) => i.key !== key));
  const updateCartItem = (key, patch) => setCart((c) => c.map((i) => (i.key === key ? { ...i, ...patch } : i)));
  const clearCart = () => setCart([]);
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.es[k] || k;

  return (
    <SiteContext.Provider value={{ settings, tours, destinations, loading, refresh, lang, setLang, t,
      theme, setTheme, cart, addToCart, removeFromCart, updateCartItem, clearCart, search, setSearch }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
